/* mears-mcmview-override-contents
export default function DeletePropertyButton(_: any) {
	return <></>
}
 */

import Button, { ButtonProps } from "../UI/Button/Button";

interface DeletePropertyButtonProps extends ButtonProps {
	plural?: boolean;
	onDelete: () => void;
}

export default function DeletePropertyButton({ plural, onDelete, ...forward }: DeletePropertyButtonProps) {
	return (
		<Button variant="contained" onClick={onDelete} {...forward}>
			Delete {plural ? "Properties" : "Property"}
		</Button>
	);
}
